import React, { useCallback, useState } from 'react';
import { useContextDispatch, useContextState } from '../context';
import { EMAIL_RGX } from '../../constant';
import { serviceSignup } from '../../src/services/serviceSignup';
import { wrapOnChange, wrapEvent, cutUserName } from '../../helper';

const SignupWrapper = ({ children, notification, sideeffect, isAuthRedundant = false }) => {
  const [email, setEmail] = useState('');
  const { notificationShowAction } = useContextDispatch();
  const { authorized } = useContextState();

  const onSubmit = useCallback(() => {
    if (EMAIL_RGX.test(email)) {
      const name = cutUserName(email);
      return serviceSignup(
        { email, name },
        (notificationConfig) => {
          (() => 2)();
          sideeffect();
          notificationShowAction(notificationConfig);
        },
        () => {
          sideeffect();
        }
      );
    }
    notificationShowAction(notification);

    return () => {};
  }, [email, notificationShowAction, sideeffect, notification]);

  const onSubmitAutorized = useCallback(() => {
    sideeffect();
  }, [sideeffect]);

  return (
    <>
      {React.cloneElement(children, {
        onChange: wrapOnChange(setEmail),
        onSubmit:
          authorized || isAuthRedundant ? wrapEvent(onSubmitAutorized) : wrapEvent(onSubmit),
      })}
    </>
  );
  //   return <WrappedComponent onChange={wrapOnChange(setEmail)} onSubmit={wrapEvent(onSubmit)} />;
};

export default SignupWrapper;
